import { v4 as uuid } from 'uuid';
import { isBooleanTrue, isNumberGreaterThanZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class OrderDiscountLine {
    id = uuid();
    code = null;
    discount = 0.0;
    discountTax = 0.0;
    discountTotal = 0.0;
    recurring = false;

    constructor(orderDiscountLine) {
        if (isObjectNotEmpty(orderDiscountLine)) {
            if (isStringNotEmpty(orderDiscountLine.id)) { this.id = orderDiscountLine.id; }
            if (isStringNotEmpty(orderDiscountLine.code)) { this.code = orderDiscountLine.code; }
            if (isNumberGreaterThanZero(orderDiscountLine.discount)) { this.discount = orderDiscountLine.discount; }
            if (isNumberGreaterThanZero(orderDiscountLine.discountTax)) { this.discountTax = orderDiscountLine.discountTax; }
            if (isNumberGreaterThanZero(orderDiscountLine.discountTotal)) { this.discountTotal = orderDiscountLine.discountTotal; }
            if (isBooleanTrue(orderDiscountLine.recurring)) { this.recurring = true; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            code: this.code,
            discount: this.discount,
            discountTax: this.discountTax,
            discountTotal: this.discountTotal,
            recurring: this.recurring
        };
    }
};

export default OrderDiscountLine;